module.exports = __webpack_public_path__ + "static/media/imprint-de.dde9d640.md";